import React from "react";
import CardCandidate from "./CardCandidate";
import constantes from '../../resources/constantes.json';
import BarraProgresoStyled from '../../components/BarraProgresoStyled';
import { fmt } from "../../utils";
import styled, { keyframes } from 'styled-components/macro';

const CardPartido = ({ codpar, nombrePartido, color, pvot, vot, cantotabla }) => {
    const basename = `${constantes.rutas.logo}${codpar.padStart(4, '0')}`;
    const { codcan, nomcan, apecan, nomcan2, apecan2 } = cantotabla[0]
    const nomPresi = nomcan + ' ' + apecan
    const nomVice = nomcan2 + ' ' + apecan2

    return (
        <CardPartidoStyled>
            <Header color={color}>
                <Logo
                    src={`${basename}.png`}
                    alt="Logo Partido" />
            </Header>
            <Body>
                <CardCandidate
                    tipo='Candidato presidente'
                    tipoImg='P'
                    codpar={codpar}
                    nombre={nomPresi}
                    codcan={codcan}
                     />
                <CardCandidate
                    tipo='Candidato vicepresidente'
                    tipoImg='V'
                    codpar={codpar}
                    nombre={nomVice}
                    codcan={codcan}
                     />

                <Separador />
                <Info>
                    <Porcentaje>{pvot}</Porcentaje>
                    <NumVotantes>{fmt(vot)}</NumVotantes>
                    <SBarraProgresoStyled
                        porcentaje={pvot.replace(/,/g, '.')}
                        color={color ? color : '#c4c4c4'}
                        cual={codpar}
                    />
                    <NomPartido>{nombrePartido}</NomPartido>

                </Info>
            </Body>
            <Footer />

        </CardPartidoStyled>
    )
}

const SBarraProgresoStyled = styled(BarraProgresoStyled)`
`

const animation_in = keyframes`
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
`;

const CardPartidoStyled = styled.div`
    width: 250px;
    min-height: 300px;
    background: #FFFFFF;
    box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.25);
    border-radius: 3px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    animation: ${animation_in} 0.5s;
    animation-timing-function: linear;
}`

const Header = styled.div`
    width: 100%;
    height: 60px;
    background: ${({ color }) => color};
    display: flex;
    justify-content: center;
    margin-bottom: 22.5%;
}`

const Logo = styled.img`
    // max-width: 67px;
    // height: 3rem;
		width: auto;
    padding: 5px;
    position: relative;
    top: 30%;
    background: white;
}`

const Body = styled.div`
    padding: 0 12px;
}`

const Separador = styled.hr`
    width:100%
`
const Info = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
}`

const Porcentaje = styled.div`
    margin-bottom: 2px;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    display: flex;
    align-items: center;
    text-align: right;
    color: #333333;
}`

const NumVotantes = styled.div`
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: right;
    color: #525252;
}`

const NomPartido = styled.div`
    min-height: 50px;
    margin: 4px 0;
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #333333;
}`

const Footer = styled.div`
    height: 12px;
    background: #1C283D;
    border-radius: 0 0 3px 3px;
}`


export default CardPartido